import { apiGet, apiPost } from '../services/apiClient';

const base = '/api/cabs';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      qs.set(key, value.join(','));
      return;
    }
    qs.set(key, String(value));
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const getCabLandingPage = () => apiGet(`${base}/landing-page`);
export const listCabVehicles = (params) => apiGet(`${base}/vehicles${buildQuery(params)}`);
export const getCabVehicle = (id) => apiGet(`${base}/vehicles/${id}`);
export const listCabCategories = () => apiGet(`${base}/vehicle-categories`);
export const listCabAmenities = () => apiGet(`${base}/amenities`);
export const listCabLocations = (params) => apiGet(`${base}/locations${buildQuery(params)}`);
export const listCabRoutes = (params) => apiGet(`${base}/routes${buildQuery(params)}`);
export const requestCabQuote = (payload) => apiPost(`${base}/quotes`, payload);
export const listCabPackages = (params) => apiGet(`${base}/packages${buildQuery(params)}`);
export const getCabPackage = (slug) => apiGet(`${base}/packages/${slug}`);
export const listCabPackageVariants = (params) => apiGet(`${base}/package-variants${buildQuery(params)}`);
export const submitCabEnquiry = (payload) => apiPost(`${base}/enquiries`, payload);
export const submitPackageEnquiry = (payload) => apiPost(`${base}/packages/enquiry`, payload);
export const listCabPopularRoutes = () => apiGet(`${base}/popular-routes`);
export const listCabPackageLocations = () => apiGet(`${base}/packages/locations`);
export const searchCabPackages = (params) => apiGet(`${base}/packages/search${buildQuery(params)}`);
export const searchCabs = (params) => apiGet(`${base}/search${buildQuery(params)}`);
